import { EditorItemType } from '../../items/item-type';

type TimedItem = {
  from: number;
  durationInFrames: number;
};

type TimingUpdate = {
  startFrame?: number;
  durationInFrames?: number;
};

const TIMING_EDITABLE_ITEM_TYPES: ReadonlySet<EditorItemType> = new Set([
  'image',
  'text',
  'solid',
  'blur',
  'pdf',
  'ppt',
  'video',
  'audio',
  'captions',
  'gif',
  'webp',
  'code',
  'group',
]);

const normalizeFps = (fps: number): number => {
  return Number.isFinite(fps) && fps > 0 ? fps : 1;
};

const normalizeFrame = (frame: number, minFrame = 0): number => {
  return Math.max(minFrame, Number.isFinite(frame) ? Math.round(frame) : 0);
};

export const canEditTimingInInspector = (item: {
  type: EditorItemType;
}): boolean => {
  return TIMING_EDITABLE_ITEM_TYPES.has(item.type);
};

export const framesToRoundedSeconds = (frames: number, fps: number): number => {
  return Math.round(normalizeFrame(frames) / normalizeFps(fps));
};

export const updateItemTiming = <TItem extends TimedItem>(
  item: TItem,
  update: TimingUpdate,
): TItem => {
  const nextFrom =
    update.startFrame === undefined
      ? item.from
      : normalizeFrame(update.startFrame);

  const nextDurationInFrames =
    update.durationInFrames === undefined
      ? item.durationInFrames
      : normalizeFrame(update.durationInFrames, 1);

  if (
    item.from === nextFrom &&
    item.durationInFrames === nextDurationInFrames
  ) {
    return item;
  }

  return {
    ...item,
    from: nextFrom,
    durationInFrames: nextDurationInFrames,
  };
};
